import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-primary to-primary-dark rounded-lg">
                <i className="ri-robot-2-line text-xl text-white"></i>
              </div>
              <span className="text-lg font-display font-bold">Digital Line AI</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Agentes de inteligencia artificial listos para transformar tu negocio y automatizar tus procesos.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full hover:border-primary hover:bg-primary/10 transition-all cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full hover:border-primary hover:bg-primary/10 transition-all cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full hover:border-primary hover:bg-primary/10 transition-all cursor-pointer">
                <i className="ri-github-line text-lg"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">Mantente informado</h4>
            <form onSubmit={handleSubmit} data-readdy-form id="newsletter-form" className="mb-4">
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Tu email"
                  required
                  className="w-full bg-transparent border-b border-gray-700 pb-2 text-sm text-white placeholder-gray-500 focus:border-primary outline-none transition-colors"
                />
                <button 
                  type="submit"
                  className="absolute right-0 bottom-2 cursor-pointer hover:opacity-70 transition-opacity"
                >
                  <i className="ri-arrow-right-line text-primary"></i>
                </button>
              </div>
            </form>
            {subscribed && (
              <p className="text-primary text-xs">¡Gracias por suscribirte!</p>
            )}
            <p className="text-xs text-gray-500">
              Al suscribirte aceptas nuestra{' '}
              <Link to="/privacy" className="underline hover:text-primary cursor-pointer transition-colors">
                política de privacidad
              </Link>
            </p>
          </div>
          
          <div>
            <h4 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">Producto</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Agentes
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Precios
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Documentación
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  API
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">Empresa</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="https://wa.me/34663035892" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-primary transition-colors cursor-pointer"
                >
                  WhatsApp: 663 035 892
                </a>
              </li>
              <li>
                <a 
                  href="mailto:project@digitalline.es"
                  className="text-sm text-gray-400 hover:text-primary transition-colors cursor-pointer"
                >
                  Email: project@digitalline.es
                </a>
              </li>
              <li>
                <a 
                  href="https://www.digitalline.es" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-primary transition-colors cursor-pointer"
                >
                  web: www.digitalline.es
                </a>
              </li>
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Términos y condiciones
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © 2025 Digital Line AI. Todos los derechos reservados.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-primary transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
      
      <div className="border-t border-gray-800 py-8 overflow-hidden">
        <div className="text-gray-800 text-8xl md:text-9xl font-display font-extrabold tracking-[0.2em] text-center select-none">
          DIGITAL LINE AI
        </div>
      </div>
    </footer>
  );
}